import React from 'react';
import { Box } from '@mui/material';
import { getProficiencyValue } from '../ProficiencyUtils';

const BarsProficiency = ({ proficiency, classes, colors }) => {
  const level = getProficiencyValue(proficiency);
  if (level === 0) return null;

  const maxLevel = 5;
  const primaryColor = colors?.primary || '#000';
  const secondaryColor = colors?.textSecondary || '#aaa';
  const barHeight = '6px';
  const barWidth = '50px';
  const filledWidth = `${(level / maxLevel) * 100}%`;

  return (
    <Box
      className={classes?.proficiencyVisualization || ''}
      sx={{
        display: 'inline-block',
        width: barWidth,
        height: barHeight,
        backgroundColor: secondaryColor,
        borderRadius: '3px',
        overflow: 'hidden',
        marginLeft: '8px',
        verticalAlign: 'middle',
      }}
    >
      <Box
        className={classes?.proficiencyFilled || ''}
        sx={{
          width: filledWidth,
          height: '100%',
          backgroundColor: primaryColor,
          borderRadius: '3px',
          transition: 'width 0.3s ease-in-out',
        }}
      />
    </Box>
  );
};

export default BarsProficiency; 